import { render } from "./GoalSection.vue?vue&type=template&id=4d98990d"
import script from "./GoalSection.vue?vue&type=script&lang=js"
export * from "./GoalSection.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__